import React from 'react';
import clsx from 'clsx';
import moment from 'moment-timezone';
import { Box, Grid } from '@material-ui/core';

import CorrectedValue from '../CorrectedValue';
import { useStyles, statusColor } from './styles';

const AxlMiniShipmentBox = (props) => {
  const { shipment, clientProfile, onClick, status, style, blurCustomerInfo, blurCustomerAddress, correctedAddress } = props;
  const classes = useStyles();
  const statusText = status || 'UNROUTED';
  const correctedInfo = correctedAddress || shipment?.dropoff_address;
  const originStreet = shipment?.dropoff_address?.street || '';
  const originAddressLine2 = `${shipment?.dropoff_address?.city}, ${shipment?.dropoff_address?.state} ${shipment?.dropoff_address?.zipcode}`;
  const correctedStreet = correctedInfo?.street || '';
  const correctedAddressLine2 = `${correctedInfo?.city}, ${correctedInfo?.state} ${correctedInfo?.zipcode}`;

  return (
    <Box onClick={() => onClick && onClick()} className={classes.container} style={{ ...style, borderRightColor: statusColor[statusText.replace(' ', '_')] }}>
      <Box className={classes.timeWindow}>
        {`${moment.tz(shipment.dropoff_earliest_ts, shipment.timezone).format('hh:mm A')} - ${moment.tz(shipment.dropoff_latest_ts, shipment.timezone).format('hh:mm A z')}`}
      </Box>
      <Grid container spacing={1}>
        <Grid item xs={2}>
          {clientProfile && (
            <div style={{ textAlign: 'center' }}>
              <img src={clientProfile.logo} alt={clientProfile.name} className={clsx({ [classes.image]: true, [classes.imgBlur]: blurCustomerInfo })} />
            </div>
          )}
        </Grid>
        <Grid item xs={5}>
          <Box className={clsx({ [classes.name]: true, [classes.blur]: blurCustomerInfo })}>{shipment && shipment.customer ? shipment.customer.name : '-'}</Box>
          <Box className={clsx({ [classes.smallText]: true, [classes.blur]: blurCustomerInfo })}>{shipment && shipment.internal_id ? shipment.internal_id : '-'}</Box>
        </Grid>
        <Grid item xs={5} style={{ textAlign: 'right' }}>
          <CorrectedValue
            originValue={originStreet} 
            correctedValue={correctedStreet} 
            originClassName={clsx({ [classes.text]: true })}
            blur={blurCustomerAddress}
          />

          <CorrectedValue
            originValue={originAddressLine2} 
            correctedValue={correctedAddressLine2} 
            originClassName={clsx({ [classes.text]: true })}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AxlMiniShipmentBox;
